const TEXT_IS_FORM_CHANGE = "fc=1"

export const Variables = {
  TEXT_IS_FORM_CHANGE,
}
